import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./auth/AuthProvider";
import { Spinner } from "./components/Icons";
import Builder from "./routes/Builder";
import Decks from "./routes/Decks";
import Join from "./routes/Join";
import Login from "./routes/Login";
import Present from "./routes/Present";
import Summary from "./routes/Summary";

function RequireAdmin({ children }: { children: React.ReactNode }) {
  const { admin, ready } = useAuth();
  // Rendering the login screen before /me answers would flash it at an
  // already-signed-in admin on every refresh.
  if (!ready) return <FullPageSpinner />;
  if (!admin) return <Navigate to="/" replace />;
  return <>{children}</>;
}

function FullPageSpinner() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        background: "var(--bg)",
      }}
    >
      <Spinner size={28} />
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route
        path="/admin"
        element={
          <RequireAdmin>
            <Decks />
          </RequireAdmin>
        }
      />
      <Route
        path="/admin/:id"
        element={
          <RequireAdmin>
            <Builder />
          </RequireAdmin>
        }
      />
      {/* Participants never sign in — the token in localStorage is their identity. */}
      <Route path="/user" element={<Join />} />
      <Route
        path="/present/:sessionId"
        element={
          <RequireAdmin>
            <Present />
          </RequireAdmin>
        }
      />
      <Route
        path="/summary/:sessionId"
        element={
          <RequireAdmin>
            <Summary />
          </RequireAdmin>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
